/* eslint-disable camelcase */
import { NullFunction } from '@deqo/foundation';
import { useEffect } from 'react';
import { ProfileData } from '../api/endpoints/me';

type IntercomSettings = {
    email?: string,
    created_at?: number,
    name?: string,
    user_id?: string,
    hide_default_launcher?: boolean,
};

const invoke = (method: string, args?: any) => {
    const itc = (window as any).Intercom || NullFunction;
    itc(method, args);
};

// Check query string for "ui" parameter
const ui = new URLSearchParams(window.location.search).get('ui') !== '0';

export const IntercomCtrl = {

    enabled: false,

    init(profile: ProfileData) {
        if (profile.id === 'US000000ANON') return null;
        if (profile.id === 'US0000000000') return null;

        const is = {} as IntercomSettings;
        is.user_id = profile.legacyId ?? profile.id;
        is.name = profile.name;
        is.email = profile.email;
        is.hide_default_launcher = !ui;

        invoke('update', is);
        IntercomCtrl.enabled = true;
    },

    show(): void {
        if (!IntercomCtrl.enabled) return;
        invoke('show');
    },

    hide(): void {
        if (!IntercomCtrl.enabled) return;
        invoke('hide');
    },

    shutdown(): void {
        if (!IntercomCtrl.enabled) return;
        invoke('shutdown');
    },
};

export const HideIntercom = () => {
    useEffect(() => {
        invoke('update', { hide_default_launcher: true });
        return () => invoke('update', { hide_default_launcher: false });
    });
    return null;
};
